export interface WorksFromNoteProps {
  /** When the code starts working, in the club's time ("2:55 PM") — formatted by the API, never computed here. */
  time: string
}

/**
 * "Works from 2:55 PM." — under a code, saying when it starts working (simulator-companion D77).
 *
 * A clock time rather than {@link AccessWindowNote}'s "N minutes before": the door and the Bay
 * PIN open at different times, and a card holding both reads more plainly with each one's time.
 *
 * @example
 * ```tsx
 * <WorksFromNote time={bayPin.opensAtLabel} />
 * ```
 */
export function WorksFromNote({ time }: WorksFromNoteProps) {
  return (
    <>
      Works from <span className="font-semibold">{time}</span>
    </>
  )
}
